module.exports = __webpack_public_path__ + "media/images/drop-down-5a72bacc18619cf71056476a8587c16c.svg";